import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";
import Header from "./components/Header";
import Footer from "./components/Footer";
import StickyBar from "./components/StickyBar";
import HomePage from "./pages/HomePage";
import ServiciiPage from "./pages/ServiciiPage";
import EchipaPage from "./pages/EchipaPage";
import CazuriPage from "./pages/CazuriPage";
import DesprePage from "./pages/DesprePage";
import RecenziiPage from "./pages/RecenziiPage";
import ContactPage from "./pages/ContactPage";
import PoliticaGdpr from "./pages/PoliticaGdpr";
import PoliticaCookies from "./pages/PoliticaCookies";
import ChestionarPage from "./pages/ChestionarPage";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/servicii" element={<ServiciiPage />} />
            <Route path="/echipa" element={<EchipaPage />} />
            <Route path="/cazuri" element={<CazuriPage />} />
            <Route path="/despre" element={<DesprePage />} />
            <Route path="/recenzii" element={<RecenziiPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/politica-gdpr" element={<PoliticaGdpr />} />
            <Route path="/politica-cookies" element={<PoliticaCookies />} />
            <Route path="/chestionar-pacient" element={<ChestionarPage />} />
            <Route path="*" element={<HomePage />} />
          </Routes>
        </main>
        <Footer />
        <StickyBar />
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
